export const GET_KHOAHOC_REQUEST = "GET_KHOAHOC_REQUEST";
export const GET_KHOAHOC_SUCCESS = "GET_KHOAHOC_SUCCESS";
export const GET_KHOAHOC_FAILURE = "GET_KHOAHOC_FAILURE";